import { API_BASE_URL } from '../config';

export interface ApiResponse<T> {
  ok: boolean;
  status: number;
  data?: T;
  error?: string;
}

export async function apiCall<T = unknown>(
  endpoint: string,
  init: RequestInit = {},
): Promise<ApiResponse<T>> {
  const url = `${API_BASE_URL}${endpoint}`;
  const token = localStorage.getItem('access_token');
  const headers = new Headers({ 'Content-Type': 'application/json' });
  if (token) headers.set('Authorization', `Bearer ${token}`);
  if (init.headers) new Headers(init.headers).forEach((v, k) => headers.set(k, v));
  try {
    const res = await fetch(url, { ...init, headers });
    if (res.status === 401) {
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      window.location.href = '/login';
    }
    const ct = res.headers.get('content-type') ?? '';
    const data = ct.includes('application/json') ? await res.json() : await res.text();
    return { ok: res.ok, status: res.status, data: data as T };
  } catch (e: unknown) {
    return { ok: false, status: 0, error: (e as Error)?.message ?? 'Network error' };
  }
}
